import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FlashMessageComponent } from './shared/components/flash-message/flash-message.component';
import { PageLoaderComponent } from './shared/components/page-loader/page-loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FlashMessageComponent, PageLoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {}
